import { ref } from 'vue'

// Shared command channel between application.js (vanilla) and PoolLines.vue (Vue).
// Commands are queued so rapid-fire calls (e.g. setManufacturer then setPool) are
// all delivered in order instead of the last-one-wins single-ref approach.
export const qsQueue = ref([])

export function enqueue(type, arg) {
  qsQueue.value = [...qsQueue.value, { type, arg }]
}
